import React from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardFooter from '../components/DashboardFooter';

const IMG_BASE = '/images/Feb18ServerSideRefactorImages/HotScams';

const GrandparentLearnMorePage = () => {
  const navigate = useNavigate();

  const allDigitalScamLinks = [
    { label: 'Phishing \\ Smishing \\ Spoofing', path: '/dashboard/phishing-learn-more' },
    { label: 'Tech Support', path: '/dashboard/tech-support-learn-more' },
    { label: 'Lottery, sweepstake', path: '/dashboard/lottery-sweepstake-learn-more' },
    { label: 'Law enforcement Impersonation', path: '/dashboard/law-enforcement-impersonation-learn-more' },
    { label: 'Government Impersonation', path: '/dashboard/government-impersonation-learn-more' },
    { label: 'Work From Home', path: '/dashboard/work-from-home-learn-more' },
    { label: 'Grandparent', path: '/dashboard/grandparent-learn-more' },
    { label: 'Crypto ATM', path: '/dashboard/crypto-atm-learn-more' },
    { label: 'Funeral', path: '/dashboard/funeral-learn-more' },
  ];

  const allConfidenceScamLinks = [
    { label: 'Pig Butcher ( Crypto )', path: '/dashboard/cryptocurrency-learn-more' },
    { label: 'Catfishing ( Romance )', path: '/dashboard/catfishing-learn-more' },
  ];

  const psaVideos = [
    'Abused in Salt Lake City',
    'No good deed ( Charity)',
    '$700,000– Price of Love',
    'Can happen to me',
    'Scam Red Flags',
    'Scam Red Flags',
    'Grandparent',
    'Grandparent',
    'Tech Support',
    'Phantom Hacker',
  ];

  return (
    <div className="h-full overflow-y-auto bg-white flex flex-col items-center">
      <div className="w-full max-w-[1920px]">

        {/* Spacer */}
        <div className="pt-6" />

        {/* 1. Hero */}
        <div className="px-12 pt-2 pb-6">
          <div className="flex gap-4" style={{ height: '256px' }}>
            <div className="flex items-center px-10" style={{ width: '33%', backgroundColor: '#93358F' }}>
              <h1 className="text-4xl font-bold text-white leading-tight">
                Grandparent
              </h1>
            </div>
            <img
              src={`${IMG_BASE}/HotScamsGrandparent.jpeg`}
              alt="Grandparent"
              className="h-full object-cover"
              style={{ width: '67%' }}
            />
          </div>
        </div>

        {/* 2. What you need to know */}
        <div className="px-12 py-6">
          <h2 className="text-2xl font-bold text-black mb-4">What you need to know</h2>
          <p className="text-black leading-relaxed mb-4">
            Hello, grandpa, its Kate, I'm in trouble and I need money now. What do mean – I really need money. Grandparent scams preys zero in on what you value most of all – a grandchild. The only thing that matters is helping your grandchildren that are in danger – you hear the fear in his, her voice.
          </p>
          <p className="text-black leading-relaxed">
            Scammers scoured the internet for personal details - social media or public records. These scammers rely on the element of surprise and urgency to extract money quickly. They want to create a sense of panic. It's important to stay calm and resist the urge to respond emotionally. By taking a step back and confirming the story through other channels, you can prevent becoming a victim of this emotional con artis trick. Always trust your instincts, and if something feels off, it probably is.
          </p>
        </div>

        {/* Personal Safety */}
        <div className="px-12 pb-6">
          <h2 className="text-xl font-bold text-black mb-2">Personal safety</h2>
          <p className="text-black leading-relaxed">
            Call the police immediately if you feel there is a danger to yourself or a loved one
          </p>
        </div>

        {/* 3. Three info cards */}
        <div className="px-12 pb-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="text-white p-6 border-l-4" style={{ backgroundColor: '#000000', borderColor: '#808080' }}>
              <h3 className="text-lg font-bold mb-4">01. Victim Impact</h3>
              <p className="text-sm mb-1">. &gt; 5,000 victims</p>
              <p className="text-sm mb-3">. &gt; $10 Million stolen</p>
              <p className="text-xs text-gray-400 mt-4">
                Source → Victim Number estimates are projections and based off news account
              </p>
            </div>
            <div className="p-6 border-l-4" style={{ backgroundColor: '#DEE9F6', borderColor: '#2E5F7F' }}>
              <h3 className="text-lg font-bold text-black mb-4">02. Warning Signs</h3>
              <ul className="space-y-2 text-black text-sm">
                <li>Unsolicited notification \\ communications.</li>
                <li>Immediate action is required.</li>
                <li>Unusual payment methods - bitcoin, gold, silver, wire transfer or gift cards.</li>
              </ul>
            </div>
            <div className="p-6 border-l-4" style={{ backgroundColor: '#DEE9F6', borderColor: '#2E5F7F' }}>
              <h3 className="text-lg font-bold text-black mb-4">03. Attach Method</h3>
              <ul className="space-y-2 text-black text-sm">
                <li>Calls \\ DM (texting) \\ Email \\ pop up messages \\ Fake website</li>
              </ul>
            </div>
          </div>
        </div>

        {/* 04. Prevention Tips */}
        <div className="px-12 py-4">
          <div className="py-8 px-12 border-l-4" style={{ backgroundColor: '#35759C', borderColor: '#ADC9E9' }}>
            <h3 className="text-lg font-bold text-white mb-4">04. Prevention Tips</h3>
            <ul className="space-y-2 text-white text-sm leading-relaxed">
              <li>- Ask personal questions the scammer won't know - nick name, special family event.</li>
              <li>- Contacting another family members first.</li>
            </ul>
          </div>
        </div>

        {/* 05. FBI PSA Videos */}
        <div className="px-12 py-10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-stretch">
            <div className="p-6 border-l-4" style={{ backgroundColor: '#ADC9E9', borderColor: '#2E5F7F' }}>
              <h3 className="text-xl font-bold text-white mb-4">05. FBI PSA Videos</h3>
              <div className="grid grid-cols-2 gap-x-8 gap-y-2 mb-6">
                {psaVideos.map((title, idx) => (
                  <p key={idx} className="text-sm text-white">{title}</p>
                ))}
              </div>
              <div className="flex justify-center">
                <button
                  onClick={() => navigate('/dashboard/av-library/fbi-ic3')}
                  className="px-12 py-3 bg-white text-black text-sm font-medium hover:bg-gray-200 transition-colors"
                >
                  Watch videos
                </button>
              </div>
            </div>
            <div>
              <img
                src={`${IMG_BASE}/HotScamsImageToTheRightOf05FBIVideosNonAssessmentPages.jpeg`}
                alt="FBI PSA"
                className="object-cover w-full h-full"
              />
            </div>
          </div>
        </div>

        {/* Category Footer */}
        <div className="px-12 pb-10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 overflow-hidden">
            <div className="p-8" style={{ backgroundColor: '#CA74C7' }}>
              <h3 className="text-2xl font-bold text-white mb-4">Know more</h3>
            </div>
            <div className="p-8" style={{ backgroundColor: '#6093D4' }}>
              <h3 className="text-2xl font-bold text-white mb-4">Digital Scams</h3>
              <div className="grid grid-cols-2 gap-x-6 gap-y-1">
                {allDigitalScamLinks.map((scam, idx) => (
                  <button
                    key={idx}
                    onClick={() => navigate(scam.path)}
                    className="text-left text-sm text-white hover:text-gray-200 py-1"
                  >
                    {scam.label}
                  </button>
                ))}
              </div>
            </div>
            <div className="p-8" style={{ backgroundColor: '#4B7C30' }}>
              <h3 className="text-2xl font-bold text-white mb-4">Confidence Scams</h3>
              <div className="space-y-1">
                {allConfidenceScamLinks.map((scam, idx) => (
                  <button
                    key={idx}
                    onClick={() => navigate(scam.path)}
                    className="block text-left text-sm text-white hover:text-gray-200 py-1"
                  >
                    {scam.label}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>

      </div>
      <DashboardFooter />
    </div>
  );
};

export default GrandparentLearnMorePage;
